type Match = {
  length: number;
  index: number;
};

export const extractHighlightCentralized = (
  text: string,
  searchRegExp: RegExp,
  // The useMaxCharactersFitOnSingleLine hook can provide the number
  maxCharactersFitOnSingleLine?: number,
): string => {
  const maxLength = Math.max(200, maxCharactersFitOnSingleLine || 0);

  if (text.match(searchRegExp)) {
    if (text.length > maxLength) {
      const matches = getMatchesOrderedByPosition(text, searchRegExp);
      return getFirstMatchCentralized(matches[0], text, maxLength);
    }
  } else {
    return text.slice(0, maxLength - 3) + "...";
  }

  return text;
};

const getMatchesOrderedByPosition = (
  text: string,
  searchRegExp: RegExp,
): Match[] => {
  return [...text.matchAll(searchRegExp)]
    .map((m) => ({
      length: m[0].length,
      index: m.index!,
    }))
    .sort((a, b) => a.index - b.index);
};

const getFirstMatchCentralized = (
  match: Match,
  text: string,
  maxLength: number,
): string => {
  const textLength = text.length;
  const halfLength = Math.trunc(maxLength - match.length) / 2;
  const { index: x, length: n } = match;

  const canBeTotallyCentered =
    x - halfLength > 0 && x + n + halfLength < textLength;
  const shouldBeSlicedInTheEnd = x - halfLength <= 0;

  if (canBeTotallyCentered) {
    // xxxxxx|...~~~~~~~~[match]~~~~~~~~...|xxx
    return (
      "..." +
      text.slice(x - halfLength + 3, x - halfLength + maxLength - 3) +
      "..."
    );
  } else if (shouldBeSlicedInTheEnd) {
    // ~~~[match]~~~~~~~~~~~~...|xxxxxx
    return text.slice(0, maxLength - 3) + "...";
  }
  // text should be sliced in the beginning
  // xxxxxxxxxxxx|...~~~~~~~~~~~[match]~~~~
  return "..." + text.slice(textLength - maxLength + 3);
};
